<template lang="pug">
div
  UiCardSection
    UiStack
      .ui-card-section-title {{ $t("admin_tools.tabs.relearn") }}
      UiSkeleton(
        v-if="relearnInProgress"
        height="1rem"
        width="160px"
      )
      .p(v-else) {{ relearnStatus }}
  UiCardSection
    RestTable(
      namespace="processed_companies"
      :headers="headers"
      ref="companiesTable"
      :fetch-handler="getData"
      :initial-filters="initialFilters"
      embed
    )
      template(#filters="{ filters, updateFilters }")
        UiStack
          UiStackItem(fill)
            UiFormGroup(:label="$t('admin_tools.relearn.company')")
              UiInput#model-input(
                :modelValue="filters.search"
                type="search"
                @update:modelValue="updateFilters({ search: $event })"
              )
          UiStackItem(fill)
            UiFormGroup(:label="$t('companies.automation.start_date')")
              UiDatePicker(
                :modelValue="filters.start_date ? new Date(filters.start_date) : null"
                type="date"
                :canClear="true"
                @update:modelValue="updateFilters({ start_date: $event ? startOfDay($event) : null })"
              )
          UiStackItem(fill)
            UiFormGroup(:label="$t('companies.automation.end_date')")
              UiDatePicker(
                :modelValue="filters.end_date ? new Date(filters.end_date) : null"
                type="date"
                :canClear="true"
                @update:modelValue="updateFilters({ end_date: $event ? endOfDay($event) : null })"
              )
      template(#cell:start_date="{ item }")
        UiDatePicker(
          type="date"
          :modelValue="item.start_date ? new Date(item.start_date) : null"
          @update:modelValue="setEdit(item.id, $event)"
        )
      template(#cell:actions="{ item }")
        UiButton(
          size="sm"
          variant="smooth-primary"
          :disabled="canBeLearned(item)"
          @click="startLearning(item)"
          icon="RefreshCcw"
        ) {{ $t("admin_tools.relearn.start_learning") }}
  UiCardSection(v-if="edited_items.length > 0")
    UiButton(
      variant="primary"
      @click="saveAll"
    ) Save changes
</template>

<script>
import ApiAdminTools from "@/api/admin_tools.js";
import { endOfDay, startOfDay } from "@bi-book/bibook-ui-kit";

export default {
  data() {
    return {
      edited_items: [],
      headers: [
        {
          key: "id",
          label: "#",
          sortable: true,
        },
        {
          key: "company_name",
          label: "Company",
          sortable: true,
        },
        {
          key: "invoices_count",
          label: "Invoices",
          sortable: true,
        },
        {
          key: "last_learning",
          label: "Relearned at",
          sortable: true,
        },
        {
          key: "start_date",
          label: "Start Date",
          sortable: true,
          width: "240px",
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
        },
        {
          key: "status_reason",
          label: "Status Reason",
          sortable: true,
        },
        {
          key: "body",
          label: "Body",
          sortable: true,
        },
        {
          key: "actions",
          label: "",
          squeeze: true,
        },
      ],
      queueCompanyIds: [],
      initialFilters: {
        start_date: null,
        end_date: null,
      },
      relearnInProgress: false,
    };
  },
  computed: {
    relearnStatus() {
      if (!this.queueCompanyIds.length) {
        return this.$t("admin_tools.relearn.free_queue");
      }
      return (
        this.$t("admin_tools.relearn.worker_is_running") +
        " " +
        this.queueCompanyIds
      );
    },
  },
  methods: {
    startOfDay: startOfDay,
    endOfDay: endOfDay,
    reloadList() {
      this.$refs.companiesTable.fetchData();
    },

    getData(params, config) {
      return ApiAdminTools.processedCompanies(params, config).then((resp) => {
        return {
          items: resp.data.companies,
          meta: resp.data.meta,
        };
      });
    },

    startLearning(item) {
      this.$dialogConfirm({
        title:
          this.$t("admin_tools.relearn.start_learning") +
          ' "' +
          item.company_name +
          '"?',
        description: this.$t("admin_tools.relearn.confirm_relearn_company"),
        variant: "warning",
        icon: "mdi mdi-alert",
        okLabel: this.$t("admin_tools.relearn.start_learning"),
        okVariant: "primary",
        okIcon: "RefreshCw",
        cancelVariant: "smooth-secondary",
      }).then((result) => {
        if (!result) return;
        ApiAdminTools.startLearning(item.id).then((resp) => {
          this.reloadList();
        });
      });
    },

    canBeLearned(item) {
      return item.is_learning;
    },

    RelearnDisabled() {
      this.relearnInProgress = true;
      ApiAdminTools.checkRelearnQueue()
        .then((resp) => {
          this.queueCompanyIds = resp.data.company_ids;
        })
        .finally(() => {
          this.relearnInProgress = false;
        });
    },

    setStartDate(item) {
      ApiAdminTools.setStartDate(item.id, item.start_date).then((resp) => {
        this.reloadList();
      });
    },

    setEdit(id, startDate) {
      this.edited_items.push({ id, start_date: startDate });
    },

    saveAll() {
      this.edited_items.forEach((item) => {
        this.setStartDate(item);
      });
      this.edited_items = [];
    },
  },

  mounted() {
    this.RelearnDisabled();
  },
};
</script>
